import { render } from "./ManageEvents.vue?vue&type=template&id=6be842c4"
import script from "./ManageEvents.vue?vue&type=script&lang=js"
export * from "./ManageEvents.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\babay\\Documents\\GitHub\\gosociali-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/Event/Manage/ManageEvents.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6be842c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6be842c4', __exports__)) {
    console.log('reload')
    api.reload('6be842c4', __exports__)
  }
  
  module.hot.accept("./ManageEvents.vue?vue&type=template&id=6be842c4", () => {
    console.log('re-render')
    api.rerender('6be842c4', render)
  })

}


export default __exports__